import { URL_BASE } from 'constants/routes';

import { InfoBox } from 'components/InfoBox';
import React from 'react';

import { Country } from '@skippay/core/@types/country';
import Link from '@skippay/core/components/Link';
import Text from '@skippay/core/components/Text';
import { FormattedMessage } from '@skippay/core/i18n/intl';

interface AlreadyHasAccountBoxProps {
	link?: JSX.Element;
	domain?: Country;
	className?: string;
}

const AlreadyHasAccountBox = ({ className, domain, link }: AlreadyHasAccountBoxProps) => {
	return (
		<InfoBox className={className}>
			<Text as="p">
				<FormattedMessage
					defaultMessage="Vypadá to, že už se známe."
					id="AlreadyHasAnAccount.title"
				/>
			</Text>
			{link || (
				<Link
					to={URL_BASE[domain || 'CZ'].url}
					testId="alreadyHasAnAccount"
					analyticsId="alreadyHasAnAccount"
				>
					<FormattedMessage
						defaultMessage="Přihlaste se kliknutím na {domain}"
						id="AlreadyHasAnAccount.link"
						values={{
							domain: URL_BASE[domain || 'CZ'].title,
						}}
					/>
				</Link>
			)}
		</InfoBox>
	);
};

export default AlreadyHasAccountBox;
